import { SystemState } from './types'

export const getAvailableCases = (state: SystemState) =>
  state.communication.inbox.cases

export const getInboxMarkedLabels = (state: SystemState) =>
  state.communication.inbox.markedLabels

export const getRemoveLabelQueue = (state: SystemState) =>
  state.communication.inbox.removeLabelsQueue

export const getMessageForCase = (state: SystemState) =>
  state.communication.inbox.messageForCase
